export const canNavigate = (to, userData) => {
  const role = userData ? userData.role : null
  const roleLevel = userData ? userData.roleLevel : null
  const horizontalRoles = userData ? userData.horizontalRoles : null

  if (!role || !roleLevel || roleLevel < 6) return false

  return to.matched
    .some(route => (!route.meta.roleLevel || roleLevel >= route.meta.roleLevel)
  && (!route.meta.horizonRole || horizontalRoles.includes(route.meta.horizonRole)))
}

export const canPrivateInternal = (to, userData) => {
  const privateInternalUser = userData ? userData.isPrivateInternal : null

  if (to.meta.privateInternal) {
    if (!privateInternalUser) return false
  }

  return true
}

export const _ = undefined
